import {EWASTE_API_PATHS} from "../constants/EWasteApiPaths";
import {callEWasteSearchApi} from "./EWasteApiHelper";

const metricProcessName = "SCC_EWASTE_ITEM_SEARCH";
const SUB_PROCESS = "searchEWasteItems";

/**
 * Search e-waste items via OculusService SearchEWasteItems.
 *
 * When {@code siteId} is supplied, the backend aggregates the site's containers
 * server-side and returns items across them with clean from/size pagination
 * (the WTN dashboard path). When omitted, callers scope to a single container
 * via queryFilters (the container-details path).
 */
export async function searchEWasteItems({
    siteId,
    from = 0,
    size = 100,
    queryFilters = [],
    sortInfos = []
} = {}) {
    const requestBody = {from, size, queryFilters, sortInfos};
    if (siteId) {
        requestBody.siteId = siteId;
    }
    return callEWasteSearchApi(
        EWASTE_API_PATHS.SEARCH_ITEMS,
        requestBody,
        metricProcessName,
        SUB_PROCESS
    );
}



// WEBPACK FOOTER //
// ./src/commons/api/SearchEWasteItems.js